const allowedFields = {
  free_chlorine_ppm_toggle: {
    label: "Free Chlorine (ppm)",
    value: "free_chlorine_ppm",
    type: "numeric"
  },
  total_chlorine_ppm_toggle: {
    label: "Total Chlorine (ppm)",
    value: "total_chlorine_ppm",
    type: "numeric"
  },
  total_bromine_ppm_toggle: {
    label: "Total Bromine (ppm)",
    value: "total_bromine_ppm",
    type: "numeric"
  },
  ph_toggle: {
    label: "pH",
    value: "ph",
    type: "numeric"
  },
  pool_temp_toggle: {
    label: "Pool Temp (F)",
    value: "pool_temp",
    type: "numeric"
  },
  air_temp_toggle: {
    label: "Air Temp (F)",
    value: "air_temp",
    type: "numeric"
  },
  water_clarity_toggle: {
    label: "Water Clarity",
    value: "water_clarity",
    source: ["Clear", "Cloudy"],
    type: "dropdown"
  },
  alkalinity_toggle: {
    label: "Alkalinity",
    value: "alkalinity",
    type: "numeric"
  },
  calcium_hardness_toggle: {
    label: "Calcium Hardness",
    value: "calcium_hardness",
    type: "numeric"
  },
  hrr_orp_toggle: {
    label: "HRR/ORP",
    value: "hrr_orp",
    type: "numeric"
  },
  custom_field_one_toggle: {
    labelField: "custom_field_one_name",
    value: "custom_field_one",
    type: "numeric"
  },
  custom_field_two_toggle: {
    labelField: "custom_field_two_name",
    value: "custom_field_two",
    type: "numeric"
  },
  custom_field_three_toggle: {
    labelField: "custom_field_three_name",
    value: "custom_field_three",
    type: "numeric"
  },
  custom_field_four_toggle: {
    labelField: "custom_field_four_name",
    value: "custom_field_four",
    type: "numeric"
  },
  custom_field_five_toggle: {
    labelField: "custom_field_five_name",
    value: "custom_field_five",
    type: "numeric"
  },
  custom_field_six_toggle: {
    labelField: "custom_field_six_name",
    value: "custom_field_six",
    type: "numeric"
  },
  custom_field_seven_toggle: {
    labelField: "custom_field_seven_name",
    value: "custom_field_seven",
    type: "numeric"
  },
  custom_field_eight_toggle: {
    labelField: "custom_field_eight_name",
    value: "custom_field_eight",
    type: "numeric"
  },
  custom_field_nine_toggle: {
    labelField: "custom_field_nine_name",
    value: "custom_field_nine",
    type: "numeric"
  },
  custom_field_ten_toggle: {
    labelField: "custom_field_ten_name",
    value: "custom_field_ten",
    type: "numeric"
  },
  custom_field_eleven_toggle: {
    labelField: "custom_field_eleven_name",
    value: "custom_field_eleven",
    type: "numeric"
  },
  custom_field_twelve_toggle: {
    labelField: "custom_field_twelve_name",
    value: "custom_field_twelve",
    type: "numeric"
  },
  backwash_toggle: {
    label: "Backwash",
    value: "backwash",
    source: ["Yes", "No"],
    type: "dropdown"
  },
  notes_toggle: {
    label: "Notes",
    value: "notes",
    type: "text"
  }
};

export const buildData = pool => {
  const colWidths = [];
  const colHeaders = [];
  const columns = [];

  // Static columns

  colWidths.push(122);
  colHeaders.push("Date");
  columns.push({
    data: "date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    correctFormat: true,
    allowEmpty: false
  });

  colWidths.push(122);
  colHeaders.push("Time");
  columns.push({
    data: "time",
    type: "time",
    correctFormat: true
  });

  for (let key in allowedFields) {
    if (!pool[key]) {
      continue;
    }

    colWidths.push(122);

    // Add header
    if (allowedFields[key].label) {
      colHeaders.push(allowedFields[key].label);
    } else if (
      allowedFields[key].labelField &&
      pool[allowedFields[key].labelField]
    ) {
      colHeaders.push(pool[allowedFields[key].labelField]);
    }

    // Add column
    const col = {
      data: allowedFields[key].value,
      type: allowedFields[key].type
    };
    if (allowedFields[key].type === "numeric") {
      col.format = "0.00";
    } else if (allowedFields[key].type === "dropdown") {
      col.source = allowedFields[key].source;
    }
    columns.push(col);
  }

  return {
    colWidths,
    colHeaders,
    columns
  };
};
